import PerkboxToken from "../utils/PerkboxToken";
export default function getSessionId(accessToken) {
    try {
        var token = new PerkboxToken(accessToken);
        return token.get("sid");
    }
    catch (e) {
        return "";
    }
}
